module.exports = __webpack_public_path__ + "img/bg-home.1e304e8f.png";